module.exports = __webpack_public_path__ + "img/btn.319614b3.png";